/* eslint-disable import/prefer-default-export */
import { useQuery } from 'react-query';
import { getCurriculumSubjectUnits } from '@apis/curriculum';

const EMPTY_UNITS = Object.freeze([]) as unknown as unknown[];

export type CurriculumSubjectLessonStub = {
  id: number;
  name: string;
  skills?: Array<{
    id: number;
    name: string;
    slug?: string;
  }>;
};

export type CurriculumSubjectUnit = {
  id: number;
  name: string;
  lessons: CurriculumSubjectLessonStub[];
  order?: number;
};

export const useGetCurriculumSubjectUnits = (
  curriculumId?: number,
  subjectId?: number,
) => {
  const queryResponse = useQuery(
    ['useGetCurriculumSubjectUnits', curriculumId, subjectId],
    async () => {
      const { response } = (await getCurriculumSubjectUnits(
        curriculumId,
        subjectId,
      )) as unknown as {
        response: { data: unknown };
      };

      return (response?.data as CurriculumSubjectUnit[]) || [];
    },
    {
      placeholderData: EMPTY_UNITS,
      useErrorBoundary: true,
      suspense: false,
      enabled: Boolean(curriculumId && subjectId),
      staleTime: 1000 * 60 * 60 * 24,
    },
  );

  return {
    units: (queryResponse.data || []) as CurriculumSubjectUnit[],
    isLoading: queryResponse.isLoading,
    error: queryResponse.error,
  };
};
